import { create, v } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { focus } from '@dojo/framework/core/middleware/focus';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import css from '../css/inline-trigger-popup.m.css';
const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
function trapFocus(event) {
    if (event.key !== 'Tab')
        return;
    const container = event.currentTarget;
    const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR));
    if (focusable.length === 0)
        return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey) {
        if (document.activeElement === first) {
            event.preventDefault();
            last.focus();
        }
    }
    else {
        if (document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }
}
const icache = createICacheMiddleware();
const factory = create({ icache, focus, theme })
    .properties()
    .children();
export const InlineTriggerPopup = factory(function ({ properties, children, middleware: { icache, focus, theme } }) {
    const { key } = properties();
    const themeCss = theme.classes(css);
    const isOpen = icache.getOrSet('open', false);
    function toggleOpen() {
        const nowOpen = !isOpen;
        icache.set('open', nowOpen);
        if (nowOpen) {
            setTimeout(() => {
                const node = document.getElementById(key);
                if (node) {
                    icache.set('wrapperRef', node);
                    node.focus();
                    document.addEventListener('click', handleOutsideClick, true);
                }
            }, 0);
        }
        else {
            document.removeEventListener('click', handleOutsideClick, true);
        }
    }
    function close() {
        icache.set('open', false);
        focus.focus();
        document.removeEventListener('click', handleOutsideClick, true);
    }
    function handleOutsideClick(event) {
        const node = icache.get('wrapperRef');
        if (node && !node.contains(event.target)) {
            close();
        }
    }
    const [{ trigger, content }] = children();
    return v('div', {
        key,
        id: key,
        tabIndex: -1,
        classes: [themeCss.inlinePopupWrapper],
        onkeydown: (event) => {
            switch (event.key) {
                case Keys.Escape:
                    if (isOpen) {
                        event.stopPropagation();
                        close();
                    }
            }
        }
    }, [
        trigger(toggleOpen),
        isOpen ? v('div', { classes: [themeCss.inlinePopupContent], onkeydown: trapFocus }, [content(close)]) : null
    ]);
});
export default InlineTriggerPopup;
